export function getRelativeURL(url) {
    // Trova l'indice del primo '/' dopo 'http://' o 'https://'
    const protocolEndIndex = url.indexOf('://') + 3; // +3 per saltare '://'
    
    // Trova la posizione del primo '/' dopo il protocollo
    const firstSlashIndex = url.indexOf('/', protocolEndIndex);
    
    // Se trova il '/', restituisce tutto ciò che viene dopo
    if (firstSlashIndex !== -1) {
        return url.slice(firstSlashIndex);
    }
    
    // Se non ci sono altri '/', restituisce solo '/'
    return '/';
}